module.exports = __webpack_public_path__ + "front/img/37.f9b3dcb3.png";